import { INVISIBLE_CHILD_PACKAGE } from '../../constants/constants';
import { htmlEncode } from '../../utils/htmlUtils';
import { CONTRACTED, INCLUDED, PROVIDER_ID_APPLETV, PROVIDER_ID_DAZN, PROVIDER_ID_DISNEY, PROVIDER_ID_MAX, PROVIDER_ID_SKY } from '@/constants/tv';
// import TvTestJson from '../../constants/TvTestJson.json';
// import TvSatelliteJson from '../../constants/TvSatelliteJson.json';

const normalizeTvText = (tvText) => {
  const stringSplitted = tvText.split('|');
  let stringFinished = stringSplitted[stringSplitted.length - 1];
  stringFinished = stringFinished.trim();

  return stringFinished;
}

export const normalizeTvHtml = (htmlString) => {
  const element = document.createElement('div');
  element.innerHTML = htmlString;

  const slidesHTMLCollection = element.getElementsByClassName('piece');
  const slides = Array.prototype.slice.call(slidesHTMLCollection);
  const slidesInfo = [];

  slides.forEach((slide) => {
    const imgTag = slide.getElementsByTagName('img')[0];
    const anchorTag = slide.getElementsByTagName('a')[0];
    let imgSrc;
    let imgAlt;
    let anchorHref;
    if (imgTag && anchorTag) {
      let auxsrc = imgTag.getAttribute('src');
      auxsrc = auxsrc.replace('http://','//');
      auxsrc = auxsrc.replace('https://','//');
      imgSrc = auxsrc;
      imgAlt = imgTag.getAttribute('alt');
      anchorHref = anchorTag.getAttribute('href');
      const text = normalizeTvText(slide.textContent);

      const slideInfo = {
        img: imgSrc,
        alt: imgAlt,
        link: anchorHref,
        text,
      };

      slidesInfo.push(slideInfo);
    }
  });

  return slidesInfo;
}

export const normalizeTvClientInfo = (response, productId) => {
  /* ONly for development

  const response = TvSatelliteJson;
  const response = TvTestJson;*/

  /* 1) PASSTHROUGH BEGINS */
  const newTVClientInfoNormalized = {
    features: response.features,
    productName: htmlEncode(response.productName),
  };
  /* 1) PASSTHROUGH ENDS  */

  /* 2) CREATING NINJA CHILD FOR ChildrenPackages.length === 0 BEGINS  */
  /* we create a copy for response for handling */
  // we have to check if every main packages have as minimum one childenPackage
  const packagesAux = response.packages;
  packagesAux.forEach((currentMainPackage) => {
    const currerntMainPackageCopied = currentMainPackage;
    currerntMainPackageCopied.name = currerntMainPackageCopied.name.replace('+80', '');
    const currentChildrenPackages = currerntMainPackageCopied.childrenPackages;
    // Check if currentChildrenPackages is empty
    if (currentChildrenPackages && currentChildrenPackages.length === 0) {
      const ninjaCurrentChild = {
        name: currentMainPackage.name,
        kind: INVISIBLE_CHILD_PACKAGE,
        description: currentMainPackage.description,
        categories: currentMainPackage.categories,
        features: currentMainPackage.features,
        info: '',
      };
      currentChildrenPackages.push(ninjaCurrentChild);
      currerntMainPackageCopied.childrenPackages = currentChildrenPackages;
    }
  });
  newTVClientInfoNormalized.packages = packagesAux;
  /* 2) CREATING NINJA CHILD FOR ChildrenPackages.length === 0 ENDS */
  /* 3) CREATING MAIN PACKAGE AND NINJA CHILD FOR channelsOnDemand BEGINS */
  if (response.channelsOnDemand.length > 0) {
    /* Creating mainPackageStructure using channlesONDemand */
    const ninjaChildChannelsOnDemandPackage = {
      name: 'A La Carta',
      kind: INVISIBLE_CHILD_PACKAGE,
      description: 'Una selección de canales a la carta de música, naturaleza, deportes, adultos y multiculturales, para completar tu TV',
      categories: [
        {
          name: '',
          channels: response.channelsOnDemand,
        },
      ],
      features: [],
      info: null,
    }
    const mainPackageForDemands = {
      name: 'A La Carta',
      productId: null,
      parentId: null,
      childrenPackages: [],
    };
    mainPackageForDemands.childrenPackages.push(ninjaChildChannelsOnDemandPackage);
    newTVClientInfoNormalized.packages.push(mainPackageForDemands);
  }
  /* 3) CREATING MAIN PACKAGE AND NINJA CHILD FOR channelsOnDemand ENDS */
  /* 4) MODIFYING HTTP --> HTTPS ON IMAGES BEGINS */

  /* 4) MODIFYING HTTP --> HTTPS ON IMAGES ENDS  replacehttp2https */
  /* 4) Assingment of productId */
  newTVClientInfoNormalized.productId = productId;

  return newTVClientInfoNormalized;
}

export const generateModule = (module) => {
  let newModule = null;
  let hired = null;
  if (module) {
    const { items, title } = module;
    if (items && Array.isArray(items) && items.length > 0) {
      hired = items.filter((item) => item.selected === true);
      hired = hired && Array.isArray(hired) && hired.length > 0 && hired.map((item) => {
        const { iconList, linkModal, title, text2, logic } = item;
        let dependencies = [];
        if (logic && logic.inputSelects && Array.isArray(logic.inputSelects) && logic.inputSelects.length > 0) {
          logic.inputSelects.forEach((input) => {
            if (input && input.options && Array.isArray(input.options) && input.options.length > 0) {
              const selected = input.options.find((option) => option.selected === true && option.default === false);
              selected && selected.label && dependencies.push(selected.label);
            }
          })
        }
        return { iconList, linkModal, title, subtitle: text2?.text , dependencies, isHired: item?.hired }
      })
      if (hired && Array.isArray(hired) && hired.length > 0 && hired.some(obj => obj?.isHired !== null)) {
        newModule = { title, hired }
      }
    }
  }
  return newModule;
}

export const normalizeTvModules = ({ modulos, productId }) => {
  let mainModules = [];
  let moviesModules = [];
  let aditionalModules = [];
  let plataformsModules = null;

  if (modulos?.tv) {
    const tv = modulos.tv;
    const { "cine-y-series": cineYSeries, esencial, futbol, otros, deportes } = tv;

    mainModules = [esencial, futbol].map(generateModule).filter(Boolean);
    moviesModules = [cineYSeries].map(generateModule).filter(Boolean);
    aditionalModules = [deportes, otros].map(generateModule).filter(Boolean);
  }

  return { productId, mainModules, moviesModules, aditionalModules, plataformsModules };
};

export const getIconProvider = (provider) => {
  let icon = null;
  switch (provider) {
    case PROVIDER_ID_DAZN:
      icon = "dazn-m";
      break;
    case PROVIDER_ID_DISNEY:
      icon = "disney-m";
      break;
    case PROVIDER_ID_MAX:
      icon = "hbo-max-m";
      break;
    case PROVIDER_ID_APPLETV:
      icon = "apple-tv-plus-logo-m";
      break;
    case PROVIDER_ID_SKY:
      icon = "showtime-m";
      break;
    default: break;
  }
  return icon;
}

export const getSrcSvgProvider = (provider) => {
  let srcSvg = null;
  switch (provider) {
    case PROVIDER_ID_DAZN:
      srcSvg = "";
      break;
    case PROVIDER_ID_DISNEY:
      srcSvg = "";
      break;
    case PROVIDER_ID_MAX:
      srcSvg = "";
      break;
    case PROVIDER_ID_APPLETV:
      srcSvg = "/content/dam/movistar/icons/canales-tv/apple-tv-plus.svg?oe=svg";
      break;
    case PROVIDER_ID_SKY:
      srcSvg = "";
      break;
    default: break;
  }
  return srcSvg;
}

export const getNameProvider = (provider) => {
  let icon = null;
  switch (provider) {
    case PROVIDER_ID_DAZN:
      icon = "DAZN";
      break;
    case PROVIDER_ID_DISNEY:
      icon = "Disney+";
      break;
    case PROVIDER_ID_MAX:
      icon = "HBO Max";
      break;
    case PROVIDER_ID_APPLETV:
      icon = "Apple TV";
      break;
    case PROVIDER_ID_SKY:
      icon = "SkyShowtime";
      break;
    default: break;
  }
  return icon;
}

export const getLabelProvider = (id, estado) => {
  if (id === PROVIDER_ID_DISNEY) {
    return estado && estado === "I" ? "Crear cuenta" : "Gestionar";
  } else if (id === PROVIDER_ID_APPLETV) {
    return "Ver detalle"
  } else {
    return "Gestionar"
  }
}

export const createProviderObject = (data, provider) => {
  if (data?.compatibles?.[0]) {
    const { addOn, compatibilidad, estado } = data.compatibles[0];
    return {
      id: provider,
      addOn,
      compatibilidad,
      estadoDisney: estado === "I" ? "Crear cuenta" : "Gestionar",
      url: (provider !== PROVIDER_ID_APPLETV) ? data?.url : null,
      label: getLabelProvider(provider, estado),
      icon: getIconProvider(provider),
      srcSvg: getSrcSvgProvider(provider),
      simpleTitle: getNameProvider(provider),
      isExternal: provider === PROVIDER_ID_DISNEY && estado === "A" ? true : false,
      isNewApi: false,
    }
  } else if (data?.compatible) {
    return {
      id: provider,
      compatibilidad: data?.compatible,
      // estadoDisney: estado === "I" ? "Crear cuenta" : "Gestionar",
      url: (provider !== PROVIDER_ID_APPLETV) ? data?.url : null,
      label: getLabelProvider(provider),
      icon: getIconProvider(provider),
      srcSvg: getSrcSvgProvider(provider),
      simpleTitle: getNameProvider(provider),
      isNewApi: true,
      // isExternal: provider === PROVIDER_ID_DISNEY && estado === "A" ? true : false,
    }
  }
}